var map = {
	"./bird-1-left.png": "9ef8",
	"./bird-10-left.png": "b0c3",
	"./bird-11-left.png": "9b29",
	"./bird-12-left.png": "212e",
	"./bird-13-left.png": "b2bd",
	"./bird-14-left.png": "a964",
	"./bird-2-left.png": "c8f4",
	"./bird-3-left.png": "71d94",
	"./bird-4-left.png": "2c2d",
	"./bird-5-left.png": "7c3f",
	"./bird-6-left.png": "c217",
	"./bird-7-left.png": "d224",
	"./bird-8-left.png": "37bf4",
	"./bird-9-left.png": "a0c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2241";